"use client";

import { useEffect, useState } from "react";

import type { CookieSchema } from "../lib/cookies/types/cookieSchema.types";
import { getCookie } from "../lib/cookies/utils/getCookie";
import { setCookie } from "../lib/cookies/utils/setCookie";

export type UseCookieProps<T = any> = {
  defaultValue?: T;
  key: string;
  schema?: CookieSchema;
};

export const useCookie = <T = any>({
  defaultValue = null,
  key,
  schema,
}: UseCookieProps<T>) => {
  const [state, setState] = useState<null | T>(
    getCookie({ key, schema }) ?? defaultValue,
  );

  useEffect(() => {
    setCookie({ key, value: state });
  }, [state]);

  return [state, setState] as const;
};
